// extracted by mini-css-extract-plugin
export default {"wrapper":"HelpCard_wrapper__T-lSD","descText":"HelpCard_descText__b63Wr","buttonsWrapper":"HelpCard_buttonsWrapper__59Qxt"};